import { useDispatch, useSelector } from 'react-redux'
import { validateCartReservations } from 'Checkout/Redux/Slices/CartSlice'
import { useReservationsVariables } from 'Checkout/Hooks/useReservationsVariables'

export const useValidateReservations = () => {
  const buildReservations = useReservationsVariables()
  const dispatch = useDispatch()
  const slug = useSelector(state => state.campground.slug)

  const buildVariables = () => ({ input: { reservations: buildReservations(), campgroundId: slug } })

  const validateReservations = () => dispatch(validateCartReservations({ variables: buildVariables() }))

  return validateReservations
}
